const sampleData = [
    {
      serial: 1,
      id: 1,
      membershipNo: 'KE01679100',
      claimNo: 'RC2201070008',
      claimDateVal: '2022-01-07 09:42 PM',
      admissionDateVal: '2021-08-09 12:00 AM',
      dischargeDateVal: '2021-08-10 11:59 PM',
      claimedAmount: '3,500.00',
      providerName: 'THE NAIROBI HOSPITAL(1)',
      billAmount: '3,500.00',
    },
    {
      serial: 2,
      id: 2,
      membershipNo: 'US02567890',
      claimNo: 'RC2201070009',
      claimDateVal: '2022-02-15 10:30 AM',
      admissionDateVal: '2022-02-14 08:00 AM',
      dischargeDateVal: '2022-02-18 05:30 PM',
      claimedAmount: '2,800.00',
      providerName: 'CAIRO GENERAL HOSPITAL',
      billAmount: '2,200.00',
    },
    {
      serial: 3,
      id: 3,
      membershipNo: 'IN01234567',
      claimNo: 'RC2201070010',
      claimDateVal: '2022-03-20 02:15 PM',
      admissionDateVal: '2022-03-18 10:00 AM',
      dischargeDateVal: '2022-03-22 11:30 AM',
      claimedAmount: '5,200.00',
      providerName: 'Toronto General Hospital',
      billAmount: '4,800.00',
    },
  ];
  
  export default sampleData;
  